import { createBrowserClient } from '@supabase/ssr';

// Module-level singleton — only ONE client instance exists for the entire app lifetime.
// Multiple instances compete over the same auth storage lock, causing:
// "Lock broken by another request with the 'steal' option" errors.
let client: ReturnType<typeof createBrowserClient> | null = null;

export function createClient() {
  if (client) return client;
  client = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookieOptions: {
        sameSite: 'none',
        secure: true,
      },
      auth: {
        // Unique storage key prevents lock collisions with other Supabase apps on same origin
        storageKey: 'cattlebooks-auth',
        // Persist session in localStorage to avoid redundant network refreshes
        persistSession: true,
        // Only detect session from URL on the auth callback page, not everywhere
        detectSessionInUrl: true,
        // Use PKCE flow for better security and fewer token refresh races
        flowType: 'pkce',
      },
    }
  );
  return client;
}